import { arrayOf, boolOf, fail, numberOf, objectOf, optionalText, requireRid, ridOf, textOf } from '../../../shared/api/wire'
import type { AqsiCreateDefaults, CreateField, CreateFieldType } from '../model/types'

const FIELD_TYPES: readonly CreateFieldType[] = ['choice', 'text', 'boolean', 'integer']
const SCHEMA = 'sync.create-template.v1'

function fieldOf(raw: unknown, name: string): CreateField {
  const item = objectOf(raw, name)
  const type = textOf(item.type, `${name}.type`)
  if (!FIELD_TYPES.includes(type as CreateFieldType)) fail(`${name}.type — неизвестный тип «${type}»`)
  const options = item.options === null || item.options === undefined
    ? []
    : arrayOf(item.options, `${name}.options`).map((entry, index) => {
        const option = objectOf(entry, `${name}.options[${index}]`)
        return { value: textOf(option.value, `${name}.options[${index}].value`), label: textOf(option.label, `${name}.options[${index}].label`) }
      })
  return {
    key: textOf(item.key, `${name}.key`),
    label: textOf(item.label, `${name}.label`),
    type: type as CreateFieldType,
    required: boolOf(item.required, `${name}.required`),
    options,
    defaultValue: optionalText(item.defaultValue, `${name}.defaultValue`),
  }
}

/** Ответ `GET/PUT sync/create-defaults` (без конверта): шаблон чужого ресурса не принимается. */
export function decodeCreateDefaults(raw: unknown, resourceId: string): AqsiCreateDefaults {
  const data = objectOf(raw, 'умолчания создания')
  const template = objectOf(data.template, 'template')
  if (template.schemaVersion !== SCHEMA) fail(`Схема шаблона создания не ${SCHEMA}`)
  const rid = ridOf(template.resourceId, 'template.resourceId')
  requireRid(rid, resourceId, 'template.resourceId')
  const version = numberOf(data.version, 'version')
  if (!Number.isSafeInteger(version) || version < 0) fail('Ревизия умолчаний — целое от 0')
  return {
    resourceId: rid,
    fields: arrayOf(template.fields, 'template.fields').map((entry, index) => fieldOf(entry, `template.fields[${index}]`)),
    version,
    updatedAt: optionalText(data.updatedAt, 'updatedAt'),
    updatedBy: optionalText(data.updatedBy, 'updatedBy'),
    problems: arrayOf(data.problems ?? [], 'problems').map((item, index) => textOf(item, `problems[${index}]`)),
  }
}
